import { render } from "./IconRocket.vue?vue&type=template&id=793e449c"
import script from "./IconRocket.vue?vue&type=script&lang=js"
export * from "./IconRocket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__